import { Injectable } from '@angular/core'
import { GridFieldSummary } from '~/models/modules/gridField';

@Injectable({
  providedIn: 'root',
})
export class CsvDataService {
  exportToCsv(filename: string, rows: object[], gridColumns: GridFieldSummary[], shwonColumns: any[]) {
    if(!rows || !rows.length){
      return;
    }
    const seperator = ',';
    let keys = gridColumns.filter(c => c.selected && c.field).map(c => c.field);

    keys = keys.sort((a, b) =>
    (gridColumns.find(c => c.field === a)?.order ?? 0) - (gridColumns.find(c => c.field === b)?.order ?? 0) != 0 ?
    (gridColumns.find(c => c.field === a)?.order ?? 0) - (gridColumns.find(c => c.field === b)?.order ?? 0) :
    gridColumns.findIndex(c => c.field === a) - gridColumns.findIndex(c => c.field === b));

    const csvContent =
        keys.map(k => gridColumns.find(c => c.field === k)?.gridFieldText?.currentText??gridColumns.find(c => c.field === k)?.title
        ).join(seperator) +
        '\n' +
        rows.map((row: any) => {
          return keys.map(k => {
            let cell: any = '';
            if (row[k] !== undefined && row[k] !== null) {
              cell = row[k];
            } else {
              const keyArray = k.split(".");
              if (keyArray.length === 1) {
                cell = (row[k] === null || row[k] === undefined) ? '' : row[k];
              } else if (keyArray.length === 2) {
                if (Array.isArray(row[keyArray[0]])) {
                  cell = (row[keyArray[0]] && row[keyArray[0]][0]) ? row[keyArray[0]][0][keyArray[1]] : null;
                }
                else {
                  cell = row[keyArray[0]] ? row[keyArray[0]][keyArray[1]] : null;
                }
              } else if (keyArray.length === 3) {
                if (Array.isArray(row[keyArray[0]])) {
                  if(!row[keyArray[0]] || row[keyArray[0]].length == 0){
                    cell = null;
                  }else{
                    cell = (row[keyArray[0]][0] && row[keyArray[0]][0][keyArray[1]]) ? row[keyArray[0]][0][keyArray[1]][keyArray[2]] : null;
                  }
                }
                else {
                  cell = (row[keyArray[0]] && row[keyArray[0]][keyArray[1]]) ? row[keyArray[0]][keyArray[1]][keyArray[2]] : null;
                }
              }
            }

            cell = cell instanceof Date
              ? cell.toLocaleString()
              : (cell?.toString() ?? '').replace(/"/g, '""');
            if (cell?.search(/("|,|\n)/g) >=0) {
              cell = `"${cell}"`;
            }
            return cell;
          }).join(seperator);
        }).join('\n');

    const blob = new Blob([csvContent], {type: 'text/csv:charset=utf-8;'});
    // if (navigator.msSaveBlob) {
    //   window.navigator.msSaveBlob(blob, filename);
    // }
    const link = document.createElement('a');
    if (link.download !== undefined) {
      const url = URL.createObjectURL(blob);
      link.setAttribute('href', url);
      link.setAttribute('download', filename);
      link.style.visibility = 'hidden';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
